import React from 'react'
import Reflux from 'reflux'
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button
} from 'reactstrap'

import QuantitiesStore from '~/stores/quantities'
import QuantitiesActions from '~/actions/quantities.js'
import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
import QuantitiesList from '~/modules/modals/quantities/list.jsx'
import QuantitiesAdd from '~/modules/modals/quantities/add.jsx'


export default class RecipeQuantitiesModal extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = QuantitiesStore
	}

	render() {
		return (
			<OnlyIfAuthorized>
				<Modal
					size="lg"
					isOpen={this.state.showQuantityModal === true}
				>
					<ModalHeader
						toggle={QuantitiesActions.hideModal}
					>
						Recipe Quantities
					</ModalHeader>
					<ModalBody>
						<QuantitiesAdd
							quantityID={0}
						/>

						<QuantitiesList />
					</ModalBody>
					<ModalFooter>
						<Button
							onClick={QuantitiesActions.hideModal}
						>
							Close Quantities
						</Button>
					</ModalFooter>
				</Modal>
			</OnlyIfAuthorized>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities.jsx